export { default } from './NotifyCustomerFields'
export type {
  NotifyCustomerFieldsProps,
  NotifyChoice
} from './NotifyCustomerFields'
